"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'spNameList',
      searchQuery: {
        spSapId: '',
        spFullName: ''
      },
      apiModule: 'kpiSet'
    };
  },
  computed: {
    domData: function domData() {
      return {
        spSapId: {
          label: this.$t('sfe.spNameList.spSapId'),
          valueKey: 'spSapId'
        },
        spFullName: {
          label: this.$t('sfe.spNameList.spFullName'),
          valueKey: 'spFullName'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.spnamelist'),
          apiUrl: '/protected/serviceProvider/export'
        },
        import: {
          apiUrl: '/protected/serviceProvider/import'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        spSapId: {
          label: this.$t('sfe.spNameList.spSapId')
        },
        spFullName: {
          label: this.$t('sfe.spNameList.spFullName')
        },
        spEnglishName: {
          label: this.$t('sfe.spNameList.spEnglishName')
        },
        spShortNameCn: {
          label: this.$t('sfe.spNameList.spShortNameCn')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/serviceProvider/querySpEnName'
      };
    }
  }
};